module.exports = __webpack_public_path__ + "img/solution-5.7b678c6b.jpg";